import React, { useEffect, useState } from 'react';
import { Button, Dialog, withStyles } from '@material-ui/core';
import ProductDelete from '../ProductDelete';

import { Redirect } from 'react-router';
import ChangePalette from '../ChangePalette';
import WatchProductDetails from './Details';
import { hasPermission, createHistory } from '../../sc-utilities';
import PrintLabelForm from '../PrintLabelForm';

import { connect } from 'react-redux';
import * as action from '../../np-core/Auth/store/authActions';
import * as actions from '../PCProduct/store/pcProductActions';
import * as actionsWatch from './store/watchProductActions';

import * as userActions from '../../np-core/User/store/userActions';
import QRCode from 'qrcode.react';
import '../qrCode.scss';
import AppLogoLoading from '../../sc-logo';
import {
    fetchBulkChangeProductsGroup,
    fetchGroups
} from "../../sc-group/Group/store/groupActions";
import ChangeGroupModal from "../../sc-users/User/ChangeGroupModal";
import AuthenticatorAppModal from "../../sc-profile/YourSettings/AuthenticatorModal";
import { hardDelete, sendErasureReports, sendExternalData } from "../PCProduct/store/pcProductActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        backgroundColor: "transparent"
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: "#e62440",
        '&:hover': {
            backgroundColor: "#757575",
        },
    },
    logo: {
        width: '250px',
        margin: '10px'
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    columnHeaderStyle: {
        paddingTop: 20,
    },
    buttonOne: {
        marginRight: 5,
        marginTop: 5,

        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    button: {
        marginRight: 5,
        marginTop: 5,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    qrCode: {
        float: 'left',
        marginRight: "0.5%",
    },
    loading: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    deleteButton: {
        backgroundColor: theme.palette.error.main,
        marginRight: 5,
        marginTop: 5,
        borderRadius: '4px',
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        }
    },
});

const ProductDetails = props => {
    const { classes, editable, setRefresh, tabValue, refresh, unlockEdit, onLoadedCleanup, deletedMedia, setDeletedMedia, permissions, onFetchProduct, translations, activeCustomer,
        activeWarehouseID, fetchGrades, fetchGradingCategories, fetchTypicalProblems, onFetchBulkChangeProductsGroup, onFetchGroups, onFetchWatchProduct, onHardDelete, twoFaEnabled,
        onSendErasureReports, onSendExternalData } = props;
    const [grades, setGrades] = useState([]);
    const [gradingCategories, setGradingCategories] = useState([]);
    const [typicalProblems, setTypicalProblems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [changePaletteModalState, setChangePaletteModalState] = useState({ orders: [], open: false });
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productID: null, redirectPath: '' });
    const [printLabelState, setPrintLabelState] = useState({ open: false, productID: null, printers: [] });
    const [isPrinted, setIsPrinted] = useState(false);
    const [external, setExternal] = useState(false);

    const [changeGroupModal, setChangeGroupModal] = useState({ open: false, ProductID: null });
    const [groups, setGroups] = useState({ list: [], loading: false });
    const [show2fa, setShow2fa] = useState({ open: false, Authentications: {} });

    const getGroups = async () => {
        setGroups(prevState => { return { ...prevState, loading: true } });
        const result = await onFetchGroups({ ActiveCustomerID: activeCustomer });
        if (result.data) {
            setGroups(prevState => { return { ...prevState, list: result.data } });
        }
        setGroups(prevState => { return { ...prevState, loading: false } });
    }

    const productHistoriesHandler = productID => {
        createHistory();
        setRedirectOptions({ redirect: true, productID: productID, redirectPath: `/product/histories?productID=${productID}` });
    };

    useEffect(() => {
        const getUserSettings = async () => {
            const result = await props.fetchUserSettings({ ActiveCustomerID: activeCustomer });
            if (result) {
                setShow2fa(prevState => {
                    return { ...prevState, Authentications: result.Authentications }
                });
            }
        }
        getUserSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            let gradeData = await fetchGrades({ ActiveCustomerID: activeCustomer });
            let gradingCategoryData = await fetchGradingCategories({ ActiveCustomerID: activeCustomer });
            let typicalProblemData = await fetchTypicalProblems({ ActiveCustomerID: activeCustomer });
            setLoading(true);
            setGrades(gradeData);
            setGradingCategories(gradingCategoryData);
            setTypicalProblems(typicalProblemData);
        }
        if (refresh && tabValue < 6 && tabValue !== 2) {
            setLoading(false)
            setRefresh(false)
        }
        if (!loading && tabValue < 6 && tabValue !== 2) {

            onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            fetchData();
        }
        if (deletedMedia) {
            onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            setDeletedMedia(false);
        }
        if (external) {
            onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            setExternal(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchGrades, refresh, props.tabValue, activeCustomer, fetchGradingCategories, external, fetchTypicalProblems, loading, onFetchProduct, onLoadedCleanup, props.productID, deletedMedia, setDeletedMedia]);

    const [deleteModalState, setDeleteModalState] = useState({ open: false, productID: null, productIDs: [], forBulk: false });
    const [redirect, setRedirect] = useState(false);

    const handleDelete = async event => {
        if (!editable) {
            return null;
        }
        if (!event) {
            setDeleteModalState({ open: false, productID: null, productIDs: [], forBulk: false });
            return;
        }
        if (event.deleted) {
            setDeleteModalState({ open: false, productID: null, productIDs: [], forBulk: false });
            setRedirect(true);
            return;
        }
        const productID = event.currentTarget.value;
        setDeleteModalState({ ...deleteModalState, open: true, productID: productID });
    };

    const handleChangePalette = async event => {
        if (!event) {
            props.onLoadedCleanup();
            props.onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            setChangePaletteModalState({ orders: [], open: false });
            setLoading(false);
            return;
        }
        let orderData = await props.fetchOrders({ ActiveCustomerID: activeCustomer });
        let collies = await props.fetchCollies({ ActiveCustomerID: activeCustomer, q: { WarehouseID: activeWarehouseID, ProductTypeKeys: 'WatchProduct' } });
        setChangePaletteModalState({ orders: orderData, open: true, Collies: collies });
    };

    const fetchData = async id => {
        await props.fetchUserSettings({ ActiveCustomerID: activeCustomer });
        let data = await props.onFetchPrinters({ ActiveCustomerID: activeCustomer });
        setPrintLabelState({ open: true, productID: id, printers: data });
    }

    const handlePrintLabel = async id => {
        if (!id) {
            setPrintLabelState({ open: false, productID: null, printers: [] });
            return;
        }
        let result = await props.onProductPrinted({ ActiveCustomerID: activeCustomer, ProductID: id })
        setPrintLabelState({ open: false, productID: id, printers: [] });
        setIsPrinted(result)
        fetchData(id);
    }

    const openChangeGroupModal = () => {
        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        setChangeGroupModal({ open: true });
    }

    const handleChangeGroupCloseSafe = () => {
        setChangeGroupModal({ open: false });
    }

    const handleChangeGroupCloseDanger = async (GroupID) => {
        setChangeGroupModal({ open: false });
        await onFetchBulkChangeProductsGroup({ ActiveCustomerID: activeCustomer, GroupID, ProductIDs: [product.ProductID] });
        await onFetchWatchProduct({ ActiveCustomerID: activeCustomer, ProductID: props.productID });
    }

    const handleSendExternalData = async event => {
        await onSendExternalData({ ActiveCustomerID: activeCustomer, ProductIDs: [props.productID] });
    }
    const handleSendErasureReports = async event => {
        await onSendErasureReports({ ActiveCustomerID: activeCustomer, ProductIDs: [props.productID] });
    }

    const product = props.product.loaded;

    useEffect(() => {
        if (product) {
            setGroups(prevState => { return { ...prevState, loadingProduct: false } });
        } else {
            setGroups(prevState => { return { ...prevState, loadingProduct: true } });
        }
    }, [product]);

    const openDeleteProductModal = () => {
        setShow2fa(prevState => { return { ...prevState, open: true } });
    }

    const closeDeleteProductModal = () => {
        setShow2fa(prevState => { return { ...prevState, open: false } });
    }

    const verifyOtp = async (OTP, Type) => {
        const res = await onHardDelete({ ActiveCustomerID: activeCustomer, OTP, Type, ProductID: product.ProductID });
        if (res === 200) {
            setShow2fa(prevState => { return { ...prevState, open: false } });
            History.goBack();
        }
    }

    const showHardDeleteButton = hasPermission(permissions, 'product_hard_delete') && twoFaEnabled && show2fa?.Authentications && Object.keys(show2fa?.Authentications)?.length > 0;


    if (redirect) {
        switch (props.type) {
            case 'WatchProduct':
                return (<Redirect to="/products/watch-products" />)
            default:
                break;
        }
    }

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    const defaultGroupValue = hasAccessAllGroupsPermission ? (product && product.GroupID && groups?.list?.find((g) => g.GroupID === product.GroupID)) || { GroupID: null, Name: translations['none'] || "None" } : (product && product.GroupID && groups?.list?.find((g) => g.GroupID === product.GroupID));

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={groups.loading} PaperProps={{ classes: { root: classes.loading } }}>
        <AppLogoLoading />
    </Dialog>


    return <>
        {hasPermission(permissions, 'product_delete') ? <ProductDelete translations={translations} activeCustomer={activeCustomer} entityName={props.type} handleDelete={handleDelete} deleteModalState={deleteModalState} deleteProduct={props.onDeleteProduct} bulkDeleteProducts={props.onBulkDeleteProducts} /> : null}
        {hasPermission(permissions, 'product_change_palette') ? <ChangePalette translations={translations} activeCustomer={activeCustomer} editable={editable} moveToAnotherPalette={props.moveToAnotherPalette} product={props.product.loaded} handleChangePalette={handleChangePalette} changePaletteState={changePaletteModalState} /> : null}

        <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={!loading && tabValue < 5 && tabValue !== 2}
            PaperProps={{
                classes: {
                    root: classes.paper
                }
            }}
        >
            <AppLogoLoading />
        </Dialog>
        <div className="tooltip">
            <QRCode
                size={50}
                className={classes.qrCode}
                value={`<Product>${product?.InventoryID}</Product>`}
            />
            <span>
                <QRCode
                    size={200}
                    value={`<Product>${product?.InventoryID}</Product>`}
                />
            </span>
        </div>
        {hasPermission(permissions, 'product_change_palette') ? <Button variant='contained' className={classes.buttonOne} disabled={!editable} onClick={handleChangePalette}>{translations['change_palettes'] || 'Change palettes'}</Button> : null}

        {hasPermission(permissions, 'product_change_group') &&
            <Button variant='contained' className={classes.button} onClick={openChangeGroupModal} disabled={!editable}>{translations["change_group"] || 'Change group'}</Button>}

        {hasPermission(permissions, 'product_get_log_data') ? <Button variant='contained' className={classes.button} onClick={props.getLogData} >{translations['get_log_data'] || 'Get log data'}</Button> : null}
        {hasPermission(permissions, 'product_delete') ? <Button variant='contained' disabled={!editable} onClick={handleDelete} className={classes.button} value={props.productID}>{translations['delete'] || 'Delete'}</Button> : null}
        {showHardDeleteButton &&
            <Button variant='contained' className={classes.deleteButton} onClick={openDeleteProductModal}>{translations["hard_delete"] || 'Hard delete'}</Button>}
        {hasPermission(permissions, 'product_view_history') && props.type !== 'StorageProduct' ? <Button variant='contained' onClick={() => productHistoriesHandler(props.productID)} className={classes.button} value={props.productID}>{translations['product_history_view'] || "View product histories"}</Button> : null}
        {hasPermission(permissions, 'product_print_label') && props.type !== 'StorageProduct' ? <Button variant='contained' onClick={() => handlePrintLabel(props.productID)} className={classes.button} value={props.productID}>{translations['print_label'] || "Print label"}</Button> : null}
        {hasPermission(permissions, 'product_unlock') ? !editable ? <Button variant='contained' className={classes.button} onClick={unlockEdit}>{translations['unlock'] || 'Unlock'}</Button> : null : null}
        {hasPermission(permissions, 'product_send_external_data') ? <Button variant='contained' className={classes.button} onClick={handleSendExternalData}>{translations['send_external_data'] || 'Send External Data'}</Button> : null}
        {hasPermission(permissions, 'product_send_erasure_report') ? <Button variant='contained' className={classes.button} onClick={handleSendErasureReports}>{translations['send_erasure_report'] || 'Send Erasure Report'}</Button> : null}
        {
            props.type === 'WatchProduct' ?
                hasPermission(permissions, 'product_load') && !refresh ? <WatchProductDetails setExternal={setExternal} external={external} editable={editable} translations={translations} activeCustomer={activeCustomer} columnsState={props.columns} saveColumnsFilter={props.saveColumnsFilter} onFetchProduct={props.onFetchProduct} setLoading={setLoading} onUnpairBulkExternalWatch={props.onUnpairBulkExternalWatch} onUnpairExternalWatch={props.onUnpairExternalWatch} activeExternalServiceAvailable={props.activeExternalServiceAvailable} permissions={permissions} product={props.product.loaded} grades={grades} gradingCategories={gradingCategories} typicalProblems={typicalProblems} onEditProduct={props.onEditProduct} onDeleteProduct={props.onDeleteProduct} onBulkDeleteProducts={props.onBulkDeleteProducts} /> : null
                : null
        }
        {hasPermission(permissions, 'product_print_label') ? <PrintLabelForm type={'watchProduct'} translations={translations} isPrinted={isPrinted} activeCustomer={activeCustomer} printLabel={props.onPrintLabelWatch} userSettings={props.userSettings} productID={printLabelState.productID} open={printLabelState.open} printers={printLabelState.printers} handleOpen={handlePrintLabel} /> : null}

        {loadingScreen}
        {!groups.loading && !groups.loadingProduct && <ChangeGroupModal permissions={permissions} defaultValue={defaultGroupValue} modalState={changeGroupModal} handleCloseDanger={handleChangeGroupCloseDanger} handleCloseSafe={handleChangeGroupCloseSafe} translations={translations} groups={groups.list} />}
        <AuthenticatorAppModal translations={translations} modal={show2fa} loginInfo={show2fa} handleClose={closeDeleteProductModal} verifyOtp={verifyOtp} submitButtonText={translations["hard_delete"] || 'Hard delete'} />
    </>
}

const mapStateToProps = state => {
    return {
        twoFaEnabled: state?.core?.login?.user?.AuthenticationEnabled,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        userSettings: state?.core?.login?.userSetting,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onProductPrinted: pcProduct => dispatch(actions.isPrintedLabel(pcProduct)),
        fetchCollies: (id) => dispatch(actions.fetchCollies(id)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        fetchUserSettings: (id) => dispatch(userActions.fetchUserSettings(id)),
        onFetchPrinters: (id) => dispatch(actions.fetchPrinters(id)),
        onPrintLabelWatch: data => dispatch(actionsWatch.printLabel(data)),
        onFetchBulkChangeProductsGroup: data => dispatch(fetchBulkChangeProductsGroup(data)),
        onFetchGroups: data => dispatch(fetchGroups(data)),
        onHardDelete: data => dispatch(hardDelete(data)),
        onSendExternalData: params => dispatch(sendExternalData(params)),
        onSendErasureReports: params => dispatch(sendErasureReports(params)),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ProductDetails))